// Module
var code = `<div class="badge badge-{{ toggleBadgeController.toggled === true ? 'success' : 'muted' }}" ng-click="toggleBadgeController.onClick"> {{ toggleBadgeController.label }} </div> `;
// Exports
module.exports = code;